/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Non-secret presentation context. It grants no identity, scope or permission.
 */
import { GUIDED_LEARNING_LOCALES, type GuidedLearningLocale } from './guided-learning';
export const CAPTURE_PRESENTATION_CONTRACT = 'QP-CAPTURE-PRESENTATION-001' as const;
export const CAPTURE_PRESENTATION_GLOBAL_KEY = '__QUBEPRO_CAPTURE_PRESENTATION__' as const;
export const CAPTURE_PRESENTATION_MODES = ['CORE_LOCALE', 'SITE_DEFAULT'] as const;
export type CapturePresentationMode = (typeof CAPTURE_PRESENTATION_MODES)[number];
export type CapturePresentation = Readonly<{
  contractId: typeof CAPTURE_PRESENTATION_CONTRACT;
  schemaVersion: 1;
  origin: string;
  locale: GuidedLearningLocale;
  mode: CapturePresentationMode;
}>;

export function parseCapturePresentation(value: unknown, expectedOrigin: string): CapturePresentation | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const candidate = value as Record<string, unknown>;
  if (Object.keys(candidate).some(key => !['contractId', 'schemaVersion', 'origin', 'locale', 'mode'].includes(key))
    || candidate.contractId !== CAPTURE_PRESENTATION_CONTRACT || candidate.schemaVersion !== 1
    || typeof candidate.locale !== 'string' || !(GUIDED_LEARNING_LOCALES as readonly string[]).includes(candidate.locale)
    || !(CAPTURE_PRESENTATION_MODES as readonly unknown[]).includes(candidate.mode)
    || candidate.origin !== expectedOrigin) return null;
  try {
    const origin = new URL(expectedOrigin);
    if (!['http:', 'https:'].includes(origin.protocol) || origin.origin !== expectedOrigin) return null;
  } catch { return null; }
  return Object.freeze({ contractId: CAPTURE_PRESENTATION_CONTRACT, schemaVersion: 1,
    origin: expectedOrigin, locale: candidate.locale as GuidedLearningLocale, mode: candidate.mode as CapturePresentationMode });
}

export function createCapturePresentation(locale: GuidedLearningLocale, origin: string, mode: CapturePresentationMode = 'CORE_LOCALE'): CapturePresentation {
  const value = parseCapturePresentation({ contractId: CAPTURE_PRESENTATION_CONTRACT, schemaVersion: 1, origin, locale, mode }, origin);
  if (!value) throw new TypeError('CAPTURE_PRESENTATION_INVALID');
  return value;
}
